import { render, staticRenderFns } from "./DeliveryPortfolio.vue?vue&type=template&id=69c980a8&scoped=true"
import script from "./DeliveryPortfolio.vue?vue&type=script&lang=js"
export * from "./DeliveryPortfolio.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPortfolio.vue?vue&type=style&index=0&id=69c980a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c980a8",
  null
  
)

export default component.exports